import { AngularFirebaseDatabaseStub } from './AngularFirebaseDatabaseStub';
import { LightWeightObjectChangeTracker } from '@schoolbelle/common/object-change-tracker';
import { Option } from '../classes';

export class TransactionServiceStub {
  constructor(
    private tracker: LightWeightObjectChangeTracker = new LightWeightObjectChangeTracker(),
    private auth = { uid: 'test', as: 'test' },
    private db: AngularFirebaseDatabaseStub = new AngularFirebaseDatabaseStub(
      tracker
    )
  ) {}
  getAgainstQuotaRef(option: any): firebase.database.Reference {
    const s_id = option.question.survey.id,
      q_id = option.question.id,
      o_id = option.id;
    return this.db.database.ref(
      `transaction/${s_id}/filled_up_to/${q_id}/${o_id}`
    ) as any;
  }
  getCheckRef(option: any, as: string): firebase.database.Reference {
    const s_id = option.question.survey.id,
      q_id = option.question.id,
      o_id = option.id;
    return this.db.database.ref(
      `transaction/${s_id}/check/${as}/${q_id}/${o_id}`
    ) as any;
  }
  set(ref: firebase.database.Reference, data: any) {
    return ref.set(data);
  }
  fromAToB(
    refOrPath: string | firebase.database.Reference,
    from: number | string | boolean = undefined,
    to: number | string | boolean = undefined
  ): Promise<any> {
    const ref =
      typeof refOrPath === 'string'
        ? this.db.database.ref(refOrPath)
        : refOrPath;
    return ref.transaction(v_o => {
      if (v_o === null) {
        return null;
      } else if (typeof from === 'undefined' || v_o === from) {
        return to;
      } else {
        return undefined;
      }
    });
  }
}
